import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import CommonSuket, { EnSuketCategory } from "@/services/CommonSuket";
import { SuketPengawetanJenazahItem } from "@/types/suket_pengawetan_jenazah";

const svc = new CommonSuket(EnSuketCategory.PengawetanJenazah);

let activeRegister: string | null = null;

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "suket-pengawetan-jenazah"
})
class SuketPengawetanJenazah extends VuexModule {
  suket: SuketPengawetanJenazahItem | null = null;
  loading = false;

  @Mutation
  SET_SUKET(suket: SuketPengawetanJenazahItem | null) {
    this.suket = suket;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Action({ rawError: true })
  async getSuketByRegister(noReg: string | number): Promise<void> {
    const register = String(noReg);

    if (activeRegister !== register) {
      activeRegister = register;
      this.SET_SUKET(null);
    }

    this.SET_LOADING(true);

    try {
      const resp = await svc.getByRegister(register);

      if (activeRegister !== register) {
        return;
      }

      this.SET_SUKET(resp.data.length ? resp.data[0] : null);
    } finally {
      this.SET_LOADING(false);
    }
  }

  @Action
  reset() {
    activeRegister = null;
    this.SET_SUKET(null);
    this.SET_LOADING(false);
  }
}

export default getModule(SuketPengawetanJenazah);
